import type { ReactNode } from 'react';
import { Card } from '@/components/ui/card';

interface ConfigurationCardProps {
  title: string;
  hint?: string;
  children: ReactNode;
}

export function ConfigurationCard({ title, hint, children }: ConfigurationCardProps) {
  return (
    <Card padding="md">
      <h2 className="text-sm font-bold text-zooindigo">{title}</h2>
      {hint !== undefined ? <p className="text-xs text-zoomuted mt-1">{hint}</p> : null}
      <div className="mt-5">{children}</div>
    </Card>
  );
}
